/* global axios */

import ApiClient from './ApiClient';

class CannedResponse extends ApiClient {
  constructor() {
    super('canned_responses', { accountScoped: true });
  }

  get({ searchKey, favorites } = {}) {
    const params = new URLSearchParams();
    if (searchKey) params.append('search', searchKey);
    if (favorites) params.append('favorites', 'true');
    const query = params.toString();
    const url = query ? `${this.url}?${query}` : this.url;
    return axios.get(url);
  }

  toggleFavorite(id, isFavorite) {
    return axios.patch(`${this.url}/${id}`, {
      canned_response: { is_favorite: isFavorite },
    });
  }

  createWithAttachments(formData) {
    return axios.post(this.url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  updateWithAttachments(id, formData) {
    return axios.patch(`${this.url}/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

export const buildCannedResponseFormData = ({
  shortCode,
  content,
  files = [],
  removeAttachmentIds = [],
}) => {
  const formData = new FormData();
  formData.append('canned_response[short_code]', shortCode);
  formData.append('canned_response[content]', content);

  files.forEach(file => {
    formData.append('canned_response[files][]', file);
  });

  removeAttachmentIds.forEach(id => {
    formData.append('canned_response[remove_attachment_ids][]', id);
  });

  return formData;
};

export default new CannedResponse();
